import { fetchMenuMarkers } from "@/api/common";

/**
 * Common module
 * 通用数据模块
 */
export default {
	namespaced: true,
	state: {
		menuMarkersCounts: {}
	},
	mutations: {
		SET_MENU_MARKETS_COUNTS(state, data) {
			state.menuMarkersCounts = data;
		}
	},
	actions: {
		async setMenuMarkersCounts({ commit, rootGetters }) {
			const { permissions } = rootGetters;

			if (
				!permissions.includes("apc/board.estimatedQuotation/index".toLowerCase()) &&
				!permissions.includes("apc/board.allocationOrder/index".toLowerCase()) &&
				!permissions.includes("apc/board.processBoard/index".toLowerCase()) &&
				!permissions.includes("apc/board.checkBom/index".toLowerCase())
			) {
				return;
			}

			const res = await fetchMenuMarkers();

			commit("SET_MENU_MARKETS_COUNTS", res.data);
		}
	}
};
